import React, { useEffect, useRef, useState } from 'react';
import { FiCalendar } from 'react-icons/fi';
import {
  formatPartnerDateForInput,
  isValidPartnerDateInput,
  PARTNER_DATE_INPUT_PLACEHOLDER,
  toPartnerIsoDate,
} from '../../Utils/partnerDateUtils';

const PartnerDateInput = ({
  value = '',
  onChange,
  className = 'form-control',
  id,
  disabled = false,
}) => {
  const pickerRef = useRef(null);
  const [displayValue, setDisplayValue] = useState(() => formatPartnerDateForInput(value));
  const isoValue = toPartnerIsoDate(value) || '';
  const isInvalid = className.includes('is-invalid');

  useEffect(() => {
    setDisplayValue(formatPartnerDateForInput(value));
  }, [value]);

  const syncIsoValue = (iso) => {
    onChange(iso);
    setDisplayValue(formatPartnerDateForInput(iso));
  };

  const handleTextChange = (event) => {
    const raw = event.target.value;
    setDisplayValue(raw);

    if (!raw.trim()) {
      onChange('');
      return;
    }

    if (isValidPartnerDateInput(raw)) {
      onChange(toPartnerIsoDate(raw));
    }
  };

  const handleTextBlur = () => {
    if (!displayValue.trim()) {
      setDisplayValue('');
      onChange('');
      return;
    }

    if (isValidPartnerDateInput(displayValue)) {
      syncIsoValue(toPartnerIsoDate(displayValue));
      return;
    }

    setDisplayValue(formatPartnerDateForInput(value));
  };

  const handlePickerChange = (event) => {
    syncIsoValue(event.target.value);
  };

  const openCalendar = () => {
    if (disabled) {
      return;
    }

    const picker = pickerRef.current;
    if (!picker) {
      return;
    }

    if (typeof picker.showPicker === 'function') {
      picker.showPicker();
      return;
    }

    picker.click();
  };

  return (
    <div className={`partner-date-input ${isInvalid ? 'is-invalid' : ''}`}>
      <input
        id={id}
        type="text"
        className="partner-date-input-field"
        value={displayValue}
        onChange={handleTextChange}
        onBlur={handleTextBlur}
        placeholder={PARTNER_DATE_INPUT_PLACEHOLDER}
        inputMode="numeric"
        disabled={disabled}
        autoComplete="off"
      />
      <input
        ref={pickerRef}
        type="date"
        className="partner-date-input-picker"
        value={isoValue}
        onChange={handlePickerChange}
        tabIndex={-1}
        aria-hidden="true"
        disabled={disabled}
      />
      <button
        type="button"
        className="partner-date-input-button"
        onClick={openCalendar}
        disabled={disabled}
        aria-label="Open calendar"
        title="Open calendar"
      >
        <FiCalendar aria-hidden="true" />
      </button>
    </div>
  );
};

export default PartnerDateInput;
